module.exports = __webpack_public_path__ + "static/media/2.e06eef33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dots/2.svg
// module id = 306
// module chunks = 0